import { pushSubscriptionJsonSchema, type PushSubscriptionJson } from '@awwyeah/shared';

/** Validates+narrows the browser's loosely-typed `PushSubscription.toJSON()` into our
 * shared, zod-checked shape before it ever crosses the network boundary. */
export function toPushSubscriptionJson(subscription: PushSubscription): PushSubscriptionJson {
  return pushSubscriptionJsonSchema.parse(subscription.toJSON());
}

/** Converts a base64url VAPID public key into the Uint8Array `PushManager.subscribe` wants. */
export function urlBase64ToUint8Array(base64Url: string): Uint8Array {
  const padding = '='.repeat((4 - (base64Url.length % 4)) % 4);
  const base64 = (base64Url + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) {
    output[i] = raw.charCodeAt(i);
  }
  return output;
}

export async function getExistingSubscription(): Promise<PushSubscription | null> {
  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.getSubscription();
}

export async function createSubscription(vapidPublicKey: string): Promise<PushSubscription> {
  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.subscribe({
    userVisibleOnly: true,
    // Cast: TS's DOM lib types ArrayBufferView as generic over ArrayBuffer specifically,
    // while a freshly-allocated Uint8Array's buffer type is the wider ArrayBufferLike.
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey) as BufferSource,
  });
}
